
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    loginPaper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    paper: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
            marginTop: theme.spacing(6),
            marginBottom: theme.spacing(6),
            padding: theme.spacing(3),
        },
    },
    layout: {
        // width: '920px !important',
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
            width: 600,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    avatar: {
        margin: theme.spacing(1),
        width: '18%',
        borderRadius: 0
        // backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    stepper: {
        // padding: theme.spacing(3, 0, 5),
        // position: "relative"
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        backgroundColor: "#212121",
        "&:hover": {
            backgroundColor: "#303030"
        }
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
        "&:hover": {
            color: "#fff",
            backgroundColor: "#303030"
        }
    },
    formControl: {
        width: "100%",
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    heading: {
        fontSize: theme.typography.pxToRem(18),
        fontWeight: theme.typography.fontWeightRegular,
    },
}));

export default useStyles;